/* Collection product card: format toggle updates price, image and product links.
   Add to cart is handled globally by bf-cart-fast.js (form.bf-inline-buy). */
(function () {
  if (window.__bfProductCard) return;
  window.__bfProductCard = true;
  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || radio.type !== 'radio') return;
    var form = radio.closest('form.bf-pcard__form');
    if (!form || !radio.checked) return;
    var card = form.closest('.bf-pcard');
    var price = form.querySelector('[data-bf-pcard-price]');
    if (price && radio.dataset.price) price.textContent = radio.dataset.price;
    if (!card) return;
    var img = card.querySelector('.bf-pcard__img');
    if (img && radio.dataset.img && img.tagName === 'IMG') {
      img.removeAttribute('srcset');
      img.src = radio.dataset.img;
    }
    card.querySelectorAll('[data-bf-pcard-link]').forEach(function (link) {
      link.href = link.dataset.base + '?variant=' + radio.value;
    });
  });
})();
